import { render, staticRenderFns } from "./QuizPool.vue?vue&type=template&id=214279d5&lang=pug"
import script from "./QuizPool.vue?vue&type=script&lang=ts"
export * from "./QuizPool.vue?vue&type=script&lang=ts"
import style0 from "./QuizPool.vue?vue&type=style&index=0&id=214279d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports